module.exports = __webpack_public_path__ + "img/logo_1.c808352d.png";